import { RootState } from 'src/store/store'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { COLOR } from 'src/constants/colors'
import Button from 'src/components/atomic/atom/Button'
import Span from 'src/components/atomic/atom/Span'
import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import Spinner from 'src/components/atomic/atom/Spinner'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setCloseModal } from 'src/store/Reducer/common/modalSlice'

const WifiListModal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { WifiInfos } = useAppSelector((state: RootState) => state.wifiInfo)

  return (
    <>
      <Span option={'medium_bold'}>
        {t('MODAL.DETECT_WIFI.TITLE', { defaultValue: 'Detect Wi-Fi' })}
      </Span>
      <Span option={'small'} $margin={'24px 0'}>
        {t('MODAL.LOCATE_WIFILIST_DESC')}
      </Span>
      <Div
        display={'flex'}
        $flex_wrap={'wrap'}
        $gap={'6px'}
        $bgColor={COLOR.black2}
        $padding={'16px'}
        $border_radius={'12px'}
        $max_height={'170px'}
        $min_height={'50px'}
        $margin={'0 0 24px 0'}
        style={{ overflowY: 'scroll' }}
      >
        {!WifiInfos ? (
          <Spinner />
        ) : (
          <>
            {WifiInfos?.length !== 0 ? (
              <>
                {WifiInfos?.map((element, idx) => (
                  <Div display={'flex'} $gap={'8px'} key={idx} width={'100%'}>
                    <Svg name={'wifiPower'} $margin={'4.5px 0'} wifipower={element.Strength} />
                    <Span option={'small'} color={COLOR.bluegray50} $text_align={'left'}>
                      {element.Name}
                    </Span>
                  </Div>
                ))}
              </>
            ) : (
              <Span option={'small'} color={COLOR.bluegray50}>
                {t('MODAL.NOT_FOUND_NETWORK', { defaultValue: 'Wi-Fi Network Not Found' })}
              </Span>
            )}
          </>
        )}
      </Div>
      <Button
        $bgColor={COLOR.brand}
        option={'modal_ok'}
        $margin={'0'}
        onClick={() => dispatch(setCloseModal())}
      >
        <Span option={'small_bold'} color={COLOR.white}>
          {t('BUTTON.OK', { defaultValue: 'OK' })}
        </Span>
      </Button>
    </>
  )
}

export default WifiListModal
